import React from 'react';
import { Link } from 'react-router-dom';
import { Beer, Wine, GlassWater, ShoppingBasket, Snowflake } from 'lucide-react';

const iconMap = {
  Beer: Beer,
  Wine: Wine,
  GlassWater: GlassWater,
  ShoppingBasket: ShoppingBasket,
  Snowflake: Snowflake,
};

export const CategoryCard = ({ category, index }) => {
  const IconComponent = iconMap[category.icon] || ShoppingBasket;
  
  // Different sizes for bento grid effect
  const sizeClasses = index === 0 
    ? 'md:col-span-2 md:row-span-2' 
    : index === 1 || index === 2 
    ? 'md:col-span-1 md:row-span-1' 
    : '';

  return (
    <Link
      to={`/produtos?categoria=${category.id}`}
      className={`group relative rounded-2xl overflow-hidden cursor-pointer ${sizeClasses}`}
      data-testid={`category-${category.id}`}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={category.image}
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full min-h-[200px] md:min-h-[240px] p-6 flex flex-col justify-end">
        <div className="flex items-center gap-3">
          <div className="bg-white/20 backdrop-blur-sm p-2 rounded-xl">
            <IconComponent className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-white text-xl md:text-2xl font-black tracking-tight">
            {category.name}
          </h3>
        </div>
        
        <p className="text-white/80 text-sm mt-2 group-hover:text-white transition-colors">
          Ver produtos →
        </p>
      </div>
    </Link>
  );
};
